import React from "react"

const VideoNote = props => {
  return (
    <>
      <div className="mb-4 overflow-hidden">
        <iframe
          className="aspect-video w-full"
          title={props.title}
          src={props.url}
          width="640"
          height="360"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <h1
        className="break-normal text-base font-medium leading-5 text-slate-800"
        dangerouslySetInnerHTML={{
          __html: props.title,
        }}
      ></h1>
      <p
        className="mt-3 text-sm leading-5 text-slate-500"
        dangerouslySetInnerHTML={{
          __html: props.description,
        }}
      ></p>
    </>
  )
}

export default VideoNote
